import { render } from "./PayBillDetailsModal.vue?vue&type=template&id=0467ecd2"
import script from "./PayBillDetailsModal.vue?vue&type=script&lang=js"
export * from "./PayBillDetailsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__